<template>
  <div v-loading="vLoadIng">
    <div class="rider-info pad_20">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('rider.detail.title') }}</span>
        </div>
      </div>
      <div class="header-info pad_10 flex">
        <div class="flex">
          <div class="head-pic flex">
            <img class="bor_rad50" v-if="form.portrait" style="width: 40px;" :src="form.portrait" alt srcset />
            <img class="bor_rad50" v-else style="width: 40px;" src="~@/assets/img/moren.png" alt srcset />
            <div class="mar_l20">
              <h4>{{ relName }}</h4>
              <span>{{ $t('rider.detail.userUid') }}{{ form.id }}</span>
            </div>
          </div>
        </div>
        <div class="flex mar_l50">
          <div class="mar_l50">
            <h4>{{ $t('rider.detail.withdrawable') }}</h4>
            <span class="color_b fon_16 wei">{{ form.useCommission || '0.00' }}</span>
          </div>
          <div class="mar_l40">
            <h4>{{ $t('rider.detail.points') }}</h4>
            <span class="color_b fon_16 wei">0</span>
          </div>
        </div>
        <div class="headState wei fon_16" v-if="form.state" :style="{ color: stateName[form.state].color }">{{ stateName[form.state].name }}</div>
      </div>
      <div class="pad_20">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item :label="$t('rider.detail.realName')" :required="true" prop="realName">
            <el-input v-model="form.realName" autocomplete="off" :placeholder="$t('rider.detail.realNamePh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.riderAccount')" :required="true" prop="userName">
            <el-input v-model="form.userName" autocomplete="off" :placeholder="$t('rider.detail.riderAccountPh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.riderPassword')" :required="true" prop="password">
            <el-input type="password" v-model="form.password" :placeholder="$t('rider.detail.riderPasswordPh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.wxAdmin')">
          <el-select v-model="form.merchantId" :placeholder="$t('rider.detail.wxAdminPh')" clearable style="width: 340px">
            <el-option v-for="item in optionsWxAdmin" :key="item.id" :label="item.userName" :value="item.id" />
          </el-select>
        </el-form-item>
          <el-form-item :label="$t('rider.detail.portrait')" :required="true" prop="portrait">
            <custom-upload v-model="form.portrait"></custom-upload>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.regTime')" :required="true" prop="userName">{{ form.createdAt }}</el-form-item>
          <el-form-item :label="$t('rider.detail.bindPhone')" :required="true" prop="tel">
            <el-input v-model="form.tel" autocomplete="off" :placeholder="$t('rider.detail.bindPhonePh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.gender')" :required="true">
            <el-radio v-model="form.sex" label="1">{{ $t('common.male') }}</el-radio>
            <el-radio v-model="form.sex" label="2">{{ $t('common.female') }}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.age')" :required="true" prop="age">
            <el-input v-model.number="form.age" autocomplete="off" :placeholder="$t('rider.detail.agePh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.urgentContact1')" :required="true" prop="age">
            <el-input v-model.number="form.urgentUsername" autocomplete="off" :placeholder="$t('rider.detail.urgentContact1Ph')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.urgentContact2')" :required="true" prop="age">
            <el-input v-model.number="form.urgentTel" autocomplete="off" :placeholder="$t('rider.detail.urgentContact2Ph')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.homeAddress')" :required="true" prop="age">
            <el-input v-model.number="form.address" autocomplete="off" :placeholder="$t('rider.detail.homeAddressPh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.riderType')" :required="true" prop="type">
            <el-select v-model="form.type" :placeholder="$t('rider.detail.riderTypePh')">
              <el-option :label="$t('rider.detail.fullTime')" :value="1"></el-option>
              <el-option :label="$t('rider.detail.partTime')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.riderLevel')" :required="true" prop="type">
            <el-select v-model="form.levelId" :placeholder="$t('common.pleaseSelect')">
              <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.idCard')" :required="true" prop="code">
            <el-input v-model="form.code" autocomplete="off" :placeholder="$t('rider.detail.idCardPh')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.idCardPhoto')">
            <el-row style="width: 500px;">
              <el-col :span="12">
                <el-form-item label-width="0px" prop="frontImg">
                  <div class="t_c">
                    <span class="fon_12">{{ $t('rider.detail.idCardFront') }}</span>
                    <div class="addpic" @click="openImage('frontImg')">
                      <img v-if="form.frontImg" :src="form.frontImg" />
                      <i v-else class="iconBtn el-icon-plus"></i>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="0px" prop="backImg">
                  <div class="t_c">
                    <span class="fon_12">{{ $t('rider.detail.idCardBack') }}</span>
                    <div class="addpic" @click="openImage('backImg')">
                      <img v-if="form.backImg" :src="form.backImg" />
                      <i v-else class="iconBtn el-icon-plus"></i>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.bond')" :required="true" prop="tel">
            <el-radio v-model="form.isBond" label="2">{{ $t('rider.detail.unpaidBond') }}</el-radio>
            <el-radio v-model="form.isBond" label="1">{{ $t('rider.detail.paidBond') }}</el-radio>
            <div>
              <el-input style="width: 200px;" v-if="form.isBond == '1'" v-model="form.bond">
                <template slot="append">{{ $t('common.yuan') }}</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.healthCert')" :required="true" prop="healthIcon">
            <div class="addpic" @click="openImage('healthIcon')">
              <img v-if="form.healthIcon" :src="form.healthIcon" />
              <i v-else class="iconBtn el-icon-plus"></i>
            </div>
          </el-form-item>
          <el-form-item :label="$t('rider.detail.authStatus')" :required="true" prop="tel">
            <el-radio v-model="form.state" label="3" v-if="form.state == '3'">{{ $t('common.notCertified') }}</el-radio>
            <el-radio v-model="form.state" label="1" v-else>{{ $t('common.notCertified') }}</el-radio>
            <el-radio v-model="form.state" label="2">{{ $t('common.certified') }}</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('rider.detail.orderStats') }}</span>
        </div>
      </div>
      <div class="flex pad_10 flex-bet">
        <div class="footer-ls">
          <h4>{{ $t('rider.detail.totalOrders') }}</h4>
          <span class="color_b">{{ form.orderNum }}</span>
        </div>
        <div class="footer-ls">
          <h4>{{ $t('rider.detail.totalTrips') }}</h4>
          <span class="color_b">{{ form.distance || '0' }}</span>
        </div>
        <div class="footer-ls">
          <h4>{{ $t('rider.detail.totalCommission') }}</h4>
          <span class="color_b">{{ form.commission || '0.00' }}</span>
        </div>
        <div class="footer-ls">
          <h4>{{ $t('rider.detail.complaintViolation') }}</h4>
          <span class="color_b">{{ form.complaint }}</span>
        </div>
      </div>
    </div>
    <div class="footer-btn flex-center mar_t20 pad_20">
      <el-button type="primary" @click="save">{{ $t('common.save') }}</el-button>
    </div>
    <attachment-img ref="selectImg" type="img" @attachment="callbackPic"></attachment-img>
  </div>
</template>

<script>
import { selectRiderLevel, riderInfo, riderSave, getMerchantId } from '@/api/rider';
import attachmentImg from '@/plugins/attachment-img.vue';
import customUpload from '@/components/custom-upload.vue';
export default {
  components: { attachmentImg, customUpload },
  data() {
    return {
      levelList: [],
      form: {
        id: '',
        userName: '',
        password: '',
        realName: '',
        portrait: '',
        healthIcon: '',
        frontImg: '',
        backImg: '',
        tel: '',
        type: '',
        sex: '1',
        age: '',
        code: '',
        bond: '1',
        isBond: '1',
        state: '1',
        levelId: '',
        urgentUsername: '',
        urgentTel: '',
        address: '',
        merchantId: ''
      },
      vLoadIng: true,
      relName: '',
      imageKey: '',
      routerName: '',
      optionsWxAdmin: [],
    };
  },
  computed: {
    stateName() {
      return {
        1: {
          name: this.$t('common.notCertified'),
          color: '#f56c6c'
        },
        2: {
          name: this.$t('common.certified'),
          color: '#2a75ed'
        },
        3: {
          name: this.$t('common.authRejected'),
          color: 'red'
        }
      };
    }
  },
  mounted() {
    const id = this.$route.query.id;
    this.routerName = this.$route.query.routerName;
    this.getLevelList(id);
    this.MerchantList(id);
  },
  methods: {
    async MerchantList(id) {
      const { data } = await getMerchantId({ id: id });
      this.optionsWxAdmin = data.merchantUser;
    },
    openImage(msg) {
      this.imageKey = msg;
      this.$refs.selectImg.dialogVisible = true;
    },
    callbackPic(e) {
      this.form[this.imageKey] = e.str;
    },
    getLevelList(id) {
      selectRiderLevel().then((res) => {
        if (res.code == 1) {
          this.levelList = res.data;
          this.levelList.forEach((item) => {
            item.id = parseInt(item.id);
          });
          this.getRiderInfo(id);
        }
      });
    },
    getRiderInfo(id) {
      riderInfo({ id: id }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.form, res.data);
          this.form.levelId = parseInt(this.form.levelId);
          this.form.type = parseInt(this.form.type);
          this.form.merchantId = this.form.userId || '';
          this.relName = this.form.realName;
          this.vLoadIng = false;
        }
      });
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { msg } = await riderSave(this.form);
          this.$baseMessage(msg, 'success');
          this.$router.push({
            name: this.routerName
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.rider-info {
  background: #ffffff;

  .header-info {
    position: relative;
    background: #F0FAFF;

    .head-pic {
      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
      }
    }

    .headState {
      position: absolute;
      right: 60px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .footer-ls {
    h4 {
      font-size: 14px;
    }

    span {
      font-size: 12px;
    }
  }
}

.footer-btn {
  text-align: center;
  background: #ffffff;
}

.addpic {
  position: relative;
  display: inline-block;
  width: 230px;
  height: 130px;
  border: 1px solid #c2c2c2;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }

  .iconBtn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
  }
}
</style>
